import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainPage from "./components/allPages/landingPage/landingPage";
import ContextProvider from "./context/DataProvider";
import ClaimLanding from "./components/allPages/claimPage/claimLanding";
import SignIn from "./components/allPages/auth/Signin";
import "./css/common.css";
import NotFound from "./NotFound";
import ClaimDetails from "./components/allPages/claimDetailsPage/claimDetails";
import InformationRequired from "./components/allPages/informationRequired/informationRequired";
import { ErrorBoundary } from "@sentry/react";
import initSnowplow from "./utils/snowplow";
import { Config } from "./config";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getMbServerToken } from "./utils/cookieUtils";
import theme from "./theme";
function App() {
  const [userName, setUserName] = useState("");
  const [userLongToken, setUserLongToken] = useState(null);
  useEffect(() => {
    const userName = localStorage.getItem("loggedInUserName");
    const userLongToken = getMbServerToken();
    const handleUnload = (event) => {
      sessionStorage.removeItem("relationName");
    };
    window.addEventListener("beforeunload", handleUnload);
    if (userName) {
      setUserName(userName);
    }
    if (userLongToken) {
      setUserLongToken(userLongToken);
    }
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, []);

  useEffect(() => {
    initSnowplow(Config.SNOWPLOW_COLLECTOR_URL);
  }, []);

  useEffect(() => {
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 5142260, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src =
        "https://static.hotjar.com/c/hotjar-" +
        h._hjSettings.hjid +
        ".js?sv=" +
        h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document);
  }, []);
  return (
    <ErrorBoundary>
        <ThemeProvider theme={theme}>
        <CssBaseline />
        <ContextProvider>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route
              path="reimbursements"
              element={
                <MainPage userName={userName} userLongToken={userLongToken} />
              }
            />
            <Route
              path="reimbursements/claim"
              element={<ClaimLanding userName={userName} />}
            />
            <Route path="reimbursements/signin" element={<SignIn />} />
            <Route
              path="reimbursements/claimdetails/:claimId"
              element={<ClaimDetails userName={userName} />}
            />
            <Route
              path="reimbursements/informationneeded/:claimId"
              element={<InformationRequired userName={userName} />}
            />
          </Routes>
        </BrowserRouter>
      </ContextProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
